module.exports = __webpack_public_path__ + "static/media/portfolio-9.12308c9b.jpg";